import { PostModel } from "../schema/post.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class PostContainer extends MongoBaseContainer{
    post: PostModel
}
